import api from "./utils/api";
import { getAuthToken } from "./utils/tokens";

const errorHandler = (apiFn) => {
  return async (...args) => {
    try {
      return await apiFn(...args);
    } catch (err) {
      // Optional: log error or show toast
      console.error("API Error:", err);
      throw err;
    }
  };
};

const createShipping = errorHandler(async (shippingData) => {
  // console.log(shippingData);
  const token = getAuthToken();
  const data = await api.post("/shipping", shippingData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

const getShipping = errorHandler(async () => {
  const token = getAuthToken();
  const data = await api.get("/shipping/admin/all", {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

// const getShippingById = errorHandler(async (id) => {
//   const token = getAuthToken();
//   const data = await api.get(`/shipping/${id}`, {
//     headers: {
//       Authorization: `Bearer ${token}`,
//     },
//   });
//   return data.data;
// });

const updateShipping = errorHandler(async (shippingId, shippingData) => {
  const token = getAuthToken();
  const data = await api.put(`/shipping/${shippingId}`, shippingData, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

const deleteShipping = errorHandler(async (id) => {
  const token = getAuthToken();
  const data = await api.delete(`/shipping/${id}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  return data.data;
});

export {
  createShipping,
  getShipping,
  //   getShippingById,
  deleteShipping,
  updateShipping,
};
